import type { ReactNode } from 'react';
import { DataNotice } from './Badges';
import { CalendarIcon } from './icons';

export function FinanceDemoNotice({ demo }: { demo: boolean }) {
  return (
    <DataNotice
      demo={demo}
      message={
        demo
          ? 'Los módulos contables y financieros requieren conexión con el servidor. Inicia sesión con un usuario real para operarlos.'
          : undefined
      }
    />
  );
}

export function TabBar<T extends string>({
  value,
  onChange,
  tabs,
  label,
}: {
  value: T;
  onChange: (value: T) => void;
  tabs: Array<{ value: T; label: string }>;
  label: string;
}) {
  return (
    <div className="segmented segmented--solid" role="tablist" aria-label={label}>
      {tabs.map((tab) => (
        <button
          key={tab.value}
          type="button"
          role="tab"
          aria-selected={value === tab.value}
          className={value === tab.value ? 'is-active' : undefined}
          onClick={() => onChange(tab.value)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

export function DateRange({
  desde,
  hasta,
  onDesde,
  onHasta,
}: {
  desde: string;
  hasta: string;
  onDesde: (value: string) => void;
  onHasta: (value: string) => void;
}) {
  return (
    <label className="date-range">
      <CalendarIcon size={16} />
      <input
        type="date"
        value={desde}
        onChange={(event) => onDesde(event.target.value)}
        aria-label="Fecha desde"
      />
      <span>—</span>
      <input
        type="date"
        value={hasta}
        onChange={(event) => onHasta(event.target.value)}
        aria-label="Fecha hasta"
      />
    </label>
  );
}

export function SummaryTile({
  label,
  value,
  hint,
  tone = 'default',
}: {
  label: string;
  value: string;
  hint?: string;
  tone?: 'default' | 'accent' | 'warning' | 'danger';
}) {
  return (
    <div className={`summary-tile summary-tile--${tone}`}>
      <span>{label}</span>
      <strong>{value}</strong>
      {hint ? <small>{hint}</small> : null}
    </div>
  );
}

export function PageToolbar({ children }: { children: ReactNode }) {
  return <div className="page-toolbar">{children}</div>;
}

export function EmptyTableRow({ colSpan, message }: { colSpan: number; message: string }) {
  return (
    <tr>
      <td colSpan={colSpan}>
        <div className="table-empty">{message}</div>
      </td>
    </tr>
  );
}
